import { axios } from '@Root/API'

export const getAll = (courseSessionId, params) => {
  return axios.get(`get/module-instances/student-course-session/${courseSessionId}`, { params })
}
